export default "__VITE_ASSET__BTKGRuW2__"